import React, { useState, useEffect } from 'react';
import { Form, Select, Input } from 'antd';
import { useRefCode } from 'hooks';

interface FormItemProps {
  form: any;
  lecture_place_type: string;
  lecture_studio: string;
  required: boolean;
  showLocation?: boolean;
}

const LecturePlaceFormItem = ({form, lecture_place_type, lecture_studio, required=false, showLocation = false}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [placeType, setPlaceType] = useState<string>(lecture_place_type);
  const [studio, setStudio] = useState<string>(lecture_studio);

  /* ======================================================
  * hooks
  * ====================================================== */
  const { refCodeList: lecturePlaceList } = useRefCode({field:'lecture_place_type', status_type: 'AV'});  
  const { refCodeList: studioList } = useRefCode({field:'lecture_studio', status_type: 'AV'});  
  /* ======================================================
  * events
  * ====================================================== */  
  useEffect(() => {
    setPlaceType(lecture_place_type);
    setStudio(lecture_studio);
  }, [lecture_place_type, lecture_studio]);
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="lecture_place_type" style={{ width:'150px', display: 'inline-block', marginRight: '5px' }} rules={[{ required: required, message: '' }]}>
        <Select placeholder="교육장소 구분 선택" onSelect={(value) => setPlaceType(value)}>
          {lecturePlaceList?.map((item) => {
              return (<Select.Option key={item.name} value={item.name}>{item.value}</Select.Option>)
          })}                        
        </Select>                
      </Form.Item> 
      {(placeType === 'ONLINE') && (
      <Form.Item name="lecture_studio" style={{ width:'150px', display: 'inline-block', marginRight: '5px' }}>
        <Select placeholder="스튜디오 선택" onSelect={(value) => setStudio(value)}>
          {studioList?.map((item) => {
              return (<Select.Option key={item.name} value={item.name}>{item.value}</Select.Option>)
          })}                        
        </Select>  
      </Form.Item> 
      )}
      {(showLocation || placeType === 'OFFLINE' || studio === 'ETC') && (
      <Form.Item name="location" style={{ width:'calc(100% - 150px - 150px - 15px)', display: 'inline-block', marginRight: '5px' }}>
        <Input type="text" placeholder='장소를 입력 하세요'/>  
      </Form.Item>        
      )}
    </>
  );
};

export default LecturePlaceFormItem;
